var map = {
	"./": 1368,
	"./Clutch": 2706,
	"./Clutch.js": 2706,
	"./NewUi": 2707,
	"./NewUi.js": 2707,
	"./OldUi": 2708,
	"./OldUi.js": 2708,
	"./index": 1368,
	"./index.js": 1368,
	"./style": 865,
	"./style.js": 865
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4251;